import Controller from '../abstracts/Controller';
import 'scss-templates/t-guest-return-request.scss';

export default class GuestReturnController extends Controller {
  static get COMPONENTS() {
    return [
      'LoginComponent',
      'ShowPasswordComponent',
      'NewsletterComponent',
      'SearchGuestOrderComponent'
    ];
  }
}
